<template>
  <div class="add-post">
    <uploaderVideo ref="uploadDiv" :uploadType="1" @uploadSucc="handleUploadSucc"></uploaderVideo>
    <div class="upload-title">
      <input type="text" maxlength="50" v-model="subjectName" placeholder="填写标题,会有更多点赞哦~"
             class="input-title"/>
    </div>
    <!-- maxlength="50" -->
    <quill-editor v-model="content" :options="editorOption"></quill-editor>
    <!-- <van-field v-model="content" rows="6" autosize type="textarea" placeholder="请输入内容" show-word-limit /> -->
    <div class="radio1" v-if="fromType === 'case' || fromType === 'ecg'">
      <div class="div-flex">
        <div class="flex-label">是否匿名</div>
        <van-radio-group v-model="changeRadio" direction="horizontal">
          <van-radio icon-size="14px" checked-color="#EB1700" name="1">是</van-radio>
          <van-radio icon-size="14px" checked-color="#EB1700" name="0">否</van-radio>
        </van-radio-group>
      </div>
      <van-field readonly clickable name="picker" class="field-color about-teacher" :value="caseValue" label="疾病分类"
                 placeholder="点击选择疾病分类" @click="showPicker = true"/>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar title="选择疾病分类" :columns="columnsCase" @confirm="onConfirm"
                    @cancel="showPicker = false"/>
      </van-popup>
      <van-field readonly clickable name="picker" class="field-color about-teacher" :value="ecgTagName"
                 label="决策树节点"
                 placeholder="点击选择决策树节点" @click="selectEcgTag"/>
      <van-popup v-model="showLabelPicker" position="bottom">
        <div class="van-picker__toolbar">
          <button type="button" class="van-picker__cancel" @click="showLabelPicker = false">取消</button>
          <div class="van-ellipsis van-picker__title">选择决策树节点</div>
          <button type="button" class="van-picker__confirm" @click="confirmEcgTag">确认</button>
        </div>
        <van-checkbox-group v-model="cacheEcgTagIds" class="ecg-tag-group">
          <van-cell v-for="item in ecgTagOptions" :key="item.value" clickable :border="false"
                    @click="toggleCheckbox(item)">
            <template #title>
              <van-checkbox :name="item && item.value" checked-color="#EB1700">{{ item && item.label }}</van-checkbox>
            </template>
          </van-cell>
        </van-checkbox-group>
      </van-popup>
    </div>
    <div class="fixed-btn" :class="{ cur: allInput, upload: uploadPost }" @click="handleAddPost">发布帖子</div>
    <div class="dialog-fixed" v-if="visiableAdd">
      <div class="dialog-bg"></div>
      <div class="dialog-cons">
        <div class="cons-title">温馨提示</div>
        <div class="cons-txt">
          因个人信息保护、广告法等相关法律法规要求，您所发布的帖子可能需要后台人员审核后方可展示。
          <div class="txt2">
            参考：<span class="col">文字帖</span>审核<span class="col">周期2小时</span>;<br>
            含<span class="col">图片/视频帖</span>审核<span class="col">周期1-3天</span>。
          </div>
        </div>
        <div class="cons-btn" @click="addSucc">我知道了</div>
      </div>
    </div>
  </div>
</template>
<script>
import {addPost, postDetails, updatePost} from '@/api/zone'
import {columnsCase, objectCase, toolbarOptions, ecgTagOptions, getEcgTagName} from './data'
import uploaderVideo from './compontents/uploaderVideo.vue'
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import withRouteTracking from '@/utils/withRouteTracking'
import {traceClickURL} from '@/utils/util'

const UserProfile = {
  components: {
    uploaderVideo,
    quillEditor
  },
  data() {
    return {
      content: '',
      subjectName: '',
      form: {},
      areaId: '', // 专区Id
      fileIds: [],
      adminFileMainId: '',
      columnsCase: columnsCase,
      ecgTagOptions,
      ecgTagIds: [],
      cacheEcgTagIds: [],
      caseValue: '',
      showLabelPicker: false,
      showPicker: false,
      changeRadio: '0',
      fromType: '',
      editorOption: {
        modules: {
          toolbar: toolbarOptions
        },
        theme: 'snow',
        placeholder: '请输入内容...'
      },
      uploadPost: false,
      visiableAdd: false,
      contentMaxLength: 1000
    }
  },
  computed: {
    allInput() {
      return this.subjectName.length > 0 && this.content.length > 0
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    ecgTagName() {
      const ids = this.ecgTagIds || []
      return ids
        .map(id => getEcgTagName(id) || '')
        .filter(name => name.trim() !== '') // 可选：过滤掉空字符串
        .join(',')
    }

  },
  created() {
    this.areaId = this.$route.query.areaId
    this.dccId = this.$route.query.dccId
    const labelId = this.$route.query.labelId
    if (this.dccId) {
      postDetails({postbarId: this.dccId}).then(res => {
        this.areaId = res.data.areaId
        this.subjectName = res.data.subjectName
        this.content = res.data.content
        this.adminFileMainId = this.dccId
        this.$refs.uploadDiv.handleFun(this.adminFileMainId)
      })
    }
    this.fromType = this.$route.query.fromType
    if (labelId) this.setLabelIds(labelId)
    if (this.fromType === 'ecg') this.caseValue = '室性心律失常'
  },
  methods: {
    selectEcgTag() {
      this.cacheEcgTagIds = [...this.ecgTagIds]
      this.showLabelPicker = true
    },
    confirmEcgTag() {
      this.ecgTagIds = [...this.cacheEcgTagIds]
      this.showLabelPicker = false
    },
    setLabelIds(labelId) {
      const labelIdsStr = labelId
      let ids = []

      if (labelIdsStr.trim() !== '') {
        ids = labelIdsStr.split(',').filter(id => id.trim() !== '')
      }

      this.ecgTagIds = ids
    },
    toggleCheckbox(item) {
      const isHas = this.cacheEcgTagIds.includes(item.value)
      if (isHas) {
        const index = this.cacheEcgTagIds.findIndex(id => id === item.value)
        this.cacheEcgTagIds.splice(index, 1)
      } else {
        this.cacheEcgTagIds.push(item.value)
      }
    },
    getPlainTextLen(richText) {
      return richText
        .replace(/<[^>]+>/g, '')
        .replace(/ |\n|\r\n|&nbsp;|&ensp;/g, '')
        .replace(/[a-zA-Z]&#7([6-7][0-9]);/g, ' ')
        .replace(/&([a-z]{2,5}|#[0-9]{1,6});/g, ' ')
        .length
    },
    handleAddPost() {
      if (!this.allInput) {
        this.$toast('请输入内容')
        return
      }
      if (this.getPlainTextLen(this.content) > this.contentMaxLength) {
        this.$toast('字数超过1000！')
        return
      }
      if (this.uploadPost) return
      this.uploadPost = true
      let params = {
        id: this.dccId,
        areaId: this.areaId,
        type: '1',
        userId: this.userInfo.id,
        subjectName: this.subjectName,
        content: this.content,
        fileIds: this.uploadList && this.uploadList.length > 0 ? this.uploadList.map(res => res.id) : [],
        // kind: 类别1RTC2病例交流3心电图交流)
        kind: this.fromType === 'case' || this.fromType === 'ecg' ? '2' : '1',
        entrance: this.fromType === 'ecg' ? 67 : null,
      }
      if (this.fromType === 'case' || this.fromType === 'ecg') {
        if (!this.caseValue) {
          this.$toast('请先选择疾病分类！')
          return
        }
        params.anonymity = this.changeRadio
        params.caseType = objectCase[this.caseValue]
        params.ecgTagIds = this.ecgTagIds
      }
      if (params.id) {
        const fileList = this.fileList.filter(item => item.id).map(item => item.id)
        params.fileIds = fileList.concat(params.fileIds)
        delete params.kind
        updatePost(params).then(res => {
          this.visiableAdd = true
          this.editType = 'update'
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      } else {
        delete params.id
        addPost(params).then(res => {
          this.visiableAdd = true
          this.editType = 'add'
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      }
    },
    addSucc() {
      if (this.editType === 'add') {
        if (this.fromType === 'ecg') {
          history.go(-1)
        } else if (this.fromType === 'case') {
          setTimeout(() => {
            traceClickURL()
          })
          window.location.href = `${process.env.bingliUrl}/wap/index.html#/homePage?index=1&listType=4`
        } else {
          this.$router.push({
            path: `/zoneDetails?areaId=${this.areaId}`
          })
        }
      } else {
        this.$router.push({
          path: `/dcc`
        })
      }
    },
    onConfirm(e) {
      this.caseValue = e
      this.showPicker = false
    },
    onConfirmEcgLabel(e) {
      console.info('🚀 ~ file: addPost.vue //// name:  --->---> ', e)
    },
    handleUploadSucc(succon) {
      this.uploadList = succon.uploadList
      this.fileList = succon.uploadList
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.dialog-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;

  .dialog-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, .6);
  }

  .dialog-cons {
    position: absolute;
    width: 322px;
    height: 273px;
    background: #fff;
    left: 50%;
    top: 50%;
    border-radius: 20px;
    transform: translate(-50%, -50%);

    .cons-title {
      font-size: 17px;
      color: #000000;
      font-weight: 600;
      line-height: 24px;
      padding-top: 16px;
      text-align: center;
      margin-bottom: 18px;
    }

    .cons-txt {
      font-size: 14px;
      color: #000;
      line-height: 24px;
      padding: 0 35px;
      box-sizing: border-box;

      .txt2 {
        margin-top: 8px;
      }

      .col {
        color: #EB1700;
      }
    }

    .cons-btn {
      width: 240px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      font-size: 16px;
      color: #FFFFFF;
      background: #EB1700;
      border-radius: 100px;
      margin-top: 30px;
      margin-left: 50%;
      transform: translateX(-50%);
    }
  }
}

.add-post {
  padding-bottom: 90px;
  box-sizing: border-box;

  .upload-imgs {
    display: flex;
    flex-wrap: wrap;
    padding: 16px 14px;
    box-sizing: border-box;

    .video-div {
      width: 109px;
      height: 109px;
      margin-right: 10px;
      position: relative;
      background-color: rgba(247 248 250, .5);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      .div-cross {
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
        background-color: rgba(0, 0, 0, .7);
        border-radius: 0 0 0 12px;

        /deep/ .cross {
          font-size: 10px;
          color: #fff;
          top: -4px;
          right: -3px;
        }
      }

      .video {
        width: 100%;
        height: 100%;
      }

      .icon-play {
        position: absolute;
        width: 36px;
        height: 36px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    /deep/ .van-uploader__wrapper {
      .van-uploader__preview,
      .van-image,
      .van-uploader__upload {
        width: 109px;
        height: 109px;
        margin-right: 10px;

        &:nth-child(3n) {
          margin-right: 0;
        }
      }

      .van-uploader__upload-icon {
        font-size: 36px;
      }
    }
  }

  .upload-title {
    width: 100%;
    border-top: 1px solid #ebedf0;
    box-sizing: border-box;
    padding: 0 14px;

    .input-title {
      line-height: 55px;
      height: 55px;
      border: none;
      border-bottom: 1px solid #ebedf0;
      font-weight: 600;
      outline: none;
      background-color: transparent;
      width: 100%;
      font-size: 18px;
      color: #282828;

      &::placeholder {
        color: #c0c0c2;
      }
    }
  }

  /deep/ .van-field__control {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);

    &::placeholder {
      color: #c0c0c2;
    }
  }

  .radio1 {
    /deep/ .van-field__control {
      text-align: right;
    }
  }

  .div-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 14px;
    height: 42px;
    border-bottom: 1px solid #ebedf0;
    font-size: 14px;
  }

  .fixed-btn {
    position: fixed;
    bottom: 24px;
    left: 14px;
    width: calc(100vw - 28px);
    height: 42px;
    border-radius: 100px;
    background-color: #e6e6e6;
    font-size: 16px;
    color: #aeaeae;
    text-align: center;
    line-height: 42px;
    font-weight: 500;

    &.upload {
      color: #fff;
      background-color: #C0C0C0;
    }

    &.cur {
      color: #fff;
      background-color: #EB1700;
    }
  }
}

/deep/ .field-color {
  .van-cell__title {
    color: #333;
    position: relative;
    padding-left: 8px;
    box-sizing: border-box;

    &::before {
      content: "*";
      font-size: 14px;
      color: #FF3C3C;
      width: 12px;
      line-height: 20px;
      position: absolute;
      top: 3px;
      left: 0;
      box-sizing: border-box;
    }
  }
}

.flex-label {
  position: relative;
  padding-left: 8px;
  box-sizing: border-box;

  &::before {
    content: "*";
    font-size: 14px;
    color: #FF3C3C;
    width: 12px;
    line-height: 20px;
    position: absolute;
    top: 3px;
    left: 0;
    box-sizing: border-box;
  }
}

.ecg-tag-group {
  overflow-y: auto;
  max-height: 60vh;
  padding-top: 10px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/addPost.vue